import { FC, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { Header, Container } from 'views/components';

import { RootState } from 'types';
import { dispatch } from 'store';
import { clearAuthError, confirmEmail } from 'modules/auth/actions';
import { WP_URL } from 'config';
import { useQuery, t } from 'utils';

import logo from 'assets/images/logo.svg';
import ready from 'assets/images/ready.png';
import styles from './ConfirmRegister.module.css';

import texts from './texts';

export const ConfirmRegister: FC = () => {
  const token = useQuery().get('token') || '';
  // store
  const { isActiveAccount, errors } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    dispatch(clearAuthError());
    if (token) {
      dispatch(confirmEmail.request(token));
    }
  }, [token]);

  useEffect(() => {
    if (isActiveAccount) {
      setTimeout(() => {
        window.location.replace(`${WP_URL}confirmation`);
      }, 2000);
    }
  }, [isActiveAccount]);

  const renderError = () => {
    for (let key in errors) {
      return <p style={{ color: 'red', fontSize: '12px' }}>{errors[key]}</p>;
    }
  };

  return (
    <div>
      <Header />
      <Container>
        <div className={styles.topWrap}>
          <a href={WP_URL}>
            <img className={styles.logo} src={logo} alt="Logo" />
          </a>
          <div className={styles.menuWrap}>
            <Link className={styles.link} to={'#'}>
              {t(texts.menu.plans)}
            </Link>
            <Link className={styles.link} to={'#'}>
              {t(texts.menu.product)}
            </Link>
            <Link className={styles.link} to={'#'}>
              {t(texts.menu.contact)}
            </Link>
            <Link className={`${styles.link} ${styles.trial}`} to={'#'}>
              {t(texts.menu.freeTrial)}{' '}
            </Link>
          </div>
        </div>

        {renderError()}
        {isActiveAccount && (
          <div className={styles.container}>
            <div className={styles.main}>
              <img src={ready} alt="ready" />
              <div style={{ marginLeft: '60px' }}>
                <h1 style={{ fontWeight: 'bold', color: '#1F77D5' }}>{t(texts.title)}</h1>
                <p>{t(texts.desc)}</p>
              </div>
            </div>
          </div>
        )}
      </Container>
    </div>
  );
};
